export const useMfa = () => process.env.REACT_APP_USE_MFA?.toLowerCase() === 'true';
